import { api } from '../api/client';
import { PUSH } from '../api/endpoints';

export const pushService = {
  getVapidPublicKey: () => api.get(PUSH.VAPID_PUBLIC_KEY),
  registerDevice: (body) => api.post(PUSH.DEVICES, body),
  unregisterDevice: (body) => api.post(PUSH.UNREGISTER, body),
};
